// Para yatırma/çekme ekranındaki bölümler (havale / kredi kartı / kripto /
// e-cüzdan). Bölümü **sunucu** çözer (`services/payment_categories.py`):
// `method_type` yalnızca bank/crypto/wallet taşır ve kredi kartı ile
// Papara'yı ayıramaz. Burada yalnızca görünüm kararları durur — sekmelerin
// adı ve sırası.
//
// Süzgeç bilinçli olarak tek yerdedir: altı kabuk da aynı `Deposit`
// sayfasını çizer, sıralamayı sayfaya kopyalamak temalar arasında farklı
// listeler doğururdu.

export const DEPOSIT_CATEGORIES = [
  { id: 'havale', name: 'Havale' },
  { id: 'kredi-karti', name: 'Kredi Kartı' },
  { id: 'kripto', name: 'Kripto' },
  { id: 'e-cuzdan', name: 'E-Cüzdan' },
];

const CATEGORY_RANK = new Map(
  DEPOSIT_CATEGORIES.map((item, index) => [item.id, index]),
);

// Sunucu bölümü bildirmezse (eski yanıt, elle eklenmiş satır) elde yalnızca
// `method_type` kalır — sunucudaki yedek eşlemenin aynısı.
const FALLBACK_BY_METHOD_TYPE = {
  crypto: 'kripto',
  wallet: 'e-cuzdan',
  bank: 'havale',
};

export const categoryOf = (method) => {
  const declared = String(method?.category || '').trim();
  if (CATEGORY_RANK.has(declared)) return declared;
  return FALLBACK_BY_METHOD_TYPE[
    String(method?.method_type || '').trim().toLowerCase()
  ] || 'havale';
};

export const categoryName = (categoryId) => (
  DEPOSIT_CATEGORIES.find((item) => item.id === categoryId)?.name || ''
);

/** Yöntemleri bölüm sırasına dizer; bölüm içinde sunucunun sırası korunur. */
export const sortByCategory = (methods) => (
  [...(methods || [])].map((method, index) => ({ method, index }))
    .sort((left, right) => {
      const delta = CATEGORY_RANK.get(categoryOf(left.method))
        - CATEGORY_RANK.get(categoryOf(right.method));
      // Bölüm içinde sağlayıcı sırası (`order`) korunur: sunucu listeyi
      // zaten o alana göre gönderir, ikinci bir ölçüt koymak panelden
      // yapılan sıralamayı yok sayardı.
      return delta !== 0 ? delta : left.index - right.index;
    })
    .map((entry) => entry.method)
);

/** Yalnızca gerçekten yöntemi olan bölümleri sekme olarak verir. */
export const availableCategories = (methods) => {
  const present = new Set((methods || []).map(categoryOf));
  return DEPOSIT_CATEGORIES.filter((item) => present.has(item.id));
};

/** "Tümü" görünümü: bölüm başlıklı gruplar, boş bölüm çizilmez. */
export const groupByCategory = (methods) => (
  DEPOSIT_CATEGORIES
    .map((category) => ({
      ...category,
      methods: (methods || []).filter(
        (method) => categoryOf(method) === category.id,
      ),
    }))
    .filter((group) => group.methods.length > 0)
);
